export const administrationAccountsHeadOfficeRscDetails = {
    template: require('./administration-accounts-head-offices-rsc-details.html'),
    controller: 'AdministrationAccountsHeadOfficeRscDetailsController'
};
